import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Tabs, Tab } from "react-bootstrap";

import { InputGroup } from "react-bootstrap";

import * as Constant from "../../../Constant.js";
import axios from '@app/lib/axios';

import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

const NURSERY_DEFAULT_VALUE = {
    id: 0,
    name: "",
    type: "",
    sub_type: "",
    ceo: "",
    director: "",
    sido: "",
    sigungu: "",
    addr: "",
    tel: "",
    class_2: 0,
    class_3: 0,
    class_4: 0,
    class_5: 0,
    class_mix: 0,
    class_2_childs: 0,
    class_3_childs: 0,
    class_4_childs: 0,
    class_5_childs: 0,
    class_mix_childs: 0,
};

const NurseryInfoTable = ({ nursery, editBtn }) => {
    const [reportModal, showReportModal] = useState(false);
    const [data, setData] = useState(0);

    useEffect(() => {
        if (nursery) setData(nursery);
        else setData(NURSERY_DEFAULT_VALUE);
        return () => {};
    }, [reportModal, nursery]);

    return (
        <table className="table table-bordered bg-light">
            <colgroup>
                <col style={{ minWidth: "100px", width: "20%" }} />
                <col />
            </colgroup>
            <tbody>
                <tr>
                    <th className="bg-dark text-light">기관 코드(ID)</th>
                    <td>
                        <span className="mt-2 text-danger">{data.code}</span>
                        <span className="float-right p-1 pl-3 pr-3 bg-info text-white">{data.service_status}</span>
                    </td>
                </tr>
                <tr>
                    <th className="bg-dark text-light">원명</th>
                    <td>
                        <span className="mt-2 text-danger">{data.name}</span>
                        {editBtn && (
                            <>
                                <button className="float-right btn btn-brand btn-rounded btn-sm pr-2 pl-2 pt-1 pb-1" onClick={() => showReportModal(true)}>
                                    원정보 수정요청
                                </button>
                                <ReportModal
                                    show={reportModal}
                                    onHide={() => {
                                        if (window.confirm("기관 정보 수정 요청을 취소 하시겠습니까?")) showReportModal(false);
                                    }}
                                    nursery={data}
                                />
                            </>
                        )}
                    </td>
                </tr>
                <tr>
                    <th className="bg-dark text-light">유형</th>
                    <td>
                        {data.type === "S" ? "유치원" : data.type === "A" ? "어린이집" : "기타"} &gt; {data.sub_type}
                    </td>
                </tr>
                <tr>
                    <th className="bg-dark text-light">대표자 명</th>
                    <td>{data.ceo || "-"}</td>
                </tr>
                <tr>
                    <th className="bg-dark text-light">원장 명</th>
                    <td>{data.director || "-"}</td>
                </tr>
                <tr>
                    <th className="bg-dark text-light">주소</th>
                    <td>{data.address || "-"}</td>
                </tr>
                <tr>
                    <th className="bg-dark text-light">전화번호</th>
                    <td>{data.tel || "-"}</td>
                </tr>
                <tr>
                    <th className="bg-dark text-light">연령/반/원아 수</th>
                    <td className="p-0">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th className="bg-dark text-light text-center">연령</th>
                                    <th className="bg-dark text-light text-center">만2세</th>
                                    <th className="bg-dark text-light text-center">만3세</th>
                                    <th className="bg-dark text-light text-center">만4세</th>
                                    <th className="bg-dark text-light text-center">만5세</th>
                                    <th className="bg-dark text-light text-center">기타</th>
                                    <th className="bg-dark text-light text-center">총합</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-center">반 수</td>
                                    <td className="text-right">{data.class_2 || 0}</td>
                                    <td className="text-right">{data.class_3 || 0}</td>
                                    <td className="text-right">{data.class_4 || 0}</td>
                                    <td className="text-right">{data.class_5 || 0}</td>
                                    <td className="text-right">{data.class_mix || 0}</td>
                                    <td className="text-right">{data.class_total || 0}</td>
                                </tr>
                                <tr>
                                    <td className="text-center">원아 수</td>
                                    <td className="text-right">{data.class_2_childs || 0}</td>
                                    <td className="text-right">{data.class_3_childs || 0}</td>
                                    <td className="text-right">{data.class_4_childs || 0}</td>
                                    <td className="text-right">{data.class_5_childs || 0}</td>
                                    <td className="text-right">{data.class_mix_childs || 0}</td>
                                    <td className="text-right">{data.childs || 0}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

const ReportModal = ({ show, onHide, nursery }) => {
    const [activeTab, setActiveTab] = useState("form");
    const [branchId, setBranchId] = useState(localStorage["login_branch_id"]);
    const [list, setList] = useState([]);
    const [description, setDescription] = useState("");
    const [gridApi, setGridApi] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    window.selectRequestData = (id) => {
        if (list) {
            const filterList = list.filter((r) => r.id === id);
            console.log(filterList);
            if (filterList.length === 1) {
                setSelectedData(filterList[0]);
            }
        }
    };

    useEffect(() => {
        if (show) {
            getList();
        }
        return () => {};
    }, [show, nursery]);

    const getList = () => {
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/nursery/report/${branchId}`,
        })
            .then((res) => {
                setList(res.data.list);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const submitReport = () => {
        if (!description.trim()) {
            alert("요청 내용이 입력되지 않았습니다.");
            return;
        }

        if (window.confirm("해당 원에 대해 DB 수정 요청을 하시겠습니까? \n*원 정보 수정에는 시일이 소요될 수 있습니다. 급한 건인 경우, 본사로 연락주시기 바랍니다.")) {
            axios({
                method: "post",
                url: `${Constant.API_DOMAIN}/api/nursery/report/${branchId}/${nursery.id}`,
                data: {
                    description: description,
                },
            })
                .then((res) => {
                    alert("요청 되었습니다");
                    setDescription("");
                    getList();
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
    };

    const listColumn = [
        {
            headerName: "No",
            headerClass: "bg-dark text-light",
            field: "id",
            sortable: false,
            width: 80,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "원명",
            headerClass: "bg-dark text-light",
            field: "name",
            sortable: false,
            width: 100,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "지역",
            headerClass: "bg-dark text-light",
            field: "loc_code",
            sortable: false,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                if (param.value) return (param.data.parent_name_sigungu ? param.data.parent_name_sigungu + " " : "") + param.data.loc_name;
                else return param.data.address;
            },
        },
        {
            headerName: "원장명",
            headerClass: "bg-dark text-light",
            field: "director",
            sortable: false,
            width: 100,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "보기",
            headerClass: "bg-dark text-light",
            field: "id",
            sortable: false,
            width: 80,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                return `<button class='btn btn-primary font-12' onClick="selectRequestData(${param.value})" style="padding: 1px 3px">보기</button>`;
            },
        },
        {
            headerName: "등록일",
            headerClass: "bg-dark text-light",
            field: "create_date",
            sortable: false,
            width: 120,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "처리 결과",
            headerClass: "bg-dark text-light",
            field: "status",
            sortable: false,
            width: 80,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                switch (param.value) {
                    case "W":
                        return '<span class="text-primary">대기중</span>';
                        break;
                    case "R":
                        return '<span class="text-danger">반려됨</span>';
                        break;
                    case "A":
                        return '<span class="">수정완료</span>';
                        break;
                    default:
                        break;
                }
            },
        },
    ];

    const onGridReady = (params) => {
        setGridApi(params.api);
        params.api.sizeColumnsToFit();
    };

    return (
        <Modal size="lg" show={show} onHide={onHide} aria-labelledby="example-custom-modal-styling-title">
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">원 정보 수정 요청</Modal.Title>
            </Modal.Header>
            <Modal.Body className="">
                <Tabs
                    activeKey={activeTab}
                    onSelect={(k) => {
                        if (gridApi) gridApi.sizeColumnsToFit();
                        setActiveTab(k);
                    }}
                    variant="pills"
                >
                    <Tab eventKey="form" title="수정 요청사항 입력" className="pt-2">
                        <NurseryInfoTable nursery={nursery} />
                        <div className="container mb-2">
                            <hr />
                            <label htmlFor="edit_nursery">위 정보 중 사실과 다른 부분에 대해 증명된 내용으로 수정 요청해 주시기 바랍니다.</label>
                            <InputGroup>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    id="description"
                                    placeholder="정보 수정 요청 사항을 이 곳에 적어 주세요."
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </InputGroup>
                            <div className="text-center m-3">
                                <button className="btn btn-brand btn-rounded" onClick={submitReport}>
                                    원 정보 수정 요청하기
                                </button>
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey="list" title="내 수정 요청 목록" className="pt-2">
                        <div className="ag-theme-balham" style={{ height: `200px`, width: "100%" }}>
                            <AgGridReact
                                onGridReady={onGridReady}
                                columnDefs={listColumn}
                                rowData={list}
                                rowClassRules={{
                                    "bg-brand-light": (params) => {
                                        return params.data.status === "W";
                                    },
                                }}
                                rowHeight={40}
                            />
                        </div>
                        {selectedData && (
                            <>
                                <hr className="pt-1 pb-1" />
                                <div className="p-3 pt-1 mt-0" style={{ maxHeight: "300px", overflow: "auto" }}>
                                    <h5 className="text-muted mb-0">&lt;요청 상세 내용&gt;</h5>
                                    <NurseryInfoTable nursery={selectedData} />
                                    <hr />
                                    <label htmlFor="edit_nursery">위 정보 중 사실과 다른 부분에 대해 증명된 내용으로 수정 요청해 주시기 바랍니다.</label>
                                    <InputGroup>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            id="description"
                                            placeholder="정보 수정 요청 사항을 이 곳에 적어 주세요."
                                            value={selectedData.description}
                                            disabled={1}
                                        />
                                    </InputGroup>
                                </div>
                            </>
                        )}
                    </Tab>
                </Tabs>
            </Modal.Body>
        </Modal>
    );
};

export default NurseryInfoTable;
